export const errorMessages = {
  required: '{field} is required',
  minlength:
    "{field} doesn't meet the required length ({actualLength}/{requiredLength})",
  maxlength: '{field} exceeds the required length ({requiredLength})',
  phoneNumberError: 'Invalid phone number',
  email: 'Invalid email format',
  min: 'Minimum value is UGX {value}',
  max: 'Maximum value is UGX {value}',
  notUnique: '{field} already exists',
};
